"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./lib/ActorSparqlSerializeTree"));
const ActorSparqlSerializeTree_1 = require("./lib/ActorSparqlSerializeTree");
const bindingsStreamToGraphQl = ActorSparqlSerializeTree_1.ActorSparqlSerializeTree.bindingsStreamToGraphQl;
exports.bindingsStreamToGraphQl = bindingsStreamToGraphQl;
//# sourceMappingURL=index.js.map